import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../../service/apiServices";

const namespace = "Department";

export const getDepartmentList = createAsyncThunk(
  `${namespace}/getDepartmentList`,
  async (body, { rejectWithValue }) => {
    const api = "departmentLists";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const postWorkingDay = createAsyncThunk(
  `${namespace}/postWorkingDay`,
  async (body, { rejectWithValue }) => {
    const api = "workingday2";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const postPersonnelByDepartment = createAsyncThunk(
  `${namespace}/postPersonnelByDepartment`,
  async (body, { rejectWithValue }) => {
    const api = "personnelbydepartment";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const postDepartmentExcel = createAsyncThunk(
  `${namespace}/postDepartmentExcel`,
  async (body, { rejectWithValue }) => {
    const api = "departmentexcel";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
const initialState = {
  workingDay2: {
    fromdate: new Date(Date.now() - 86400000).toISOString().slice(0, 10),
    todate: new Date().toISOString().slice(0, 10),
  },
  departmentReport: {
    departments: {
      id: " ",
    },
    fromdate: "",
    todate: "",
  },
};

const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    updateWorkingDay(state, action) {
      return { ...state, workingDay2: action.payload };
    },
    updatePersonnelByDepartment(state, action) {
      return { ...state, departmentReport: action.payload };
    },
    resetDepartmentReport(state, action) {
      return { ...state, workingDay2: initialState.workingDay2, departmentReport:initialState.departmentReport };
    },
  },

  extraReducers: {
    [postWorkingDay.pending]: (state, action) => {
      state.loading = true;
    },
    [postWorkingDay.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [postWorkingDay.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [postPersonnelByDepartment.pending]: (state, action) => {
      state.loading = true;
    },
    [postPersonnelByDepartment.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [postPersonnelByDepartment.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [postDepartmentExcel.pending]: (state, action) => {
      state.loading = true;
    },
    [postDepartmentExcel.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [postDepartmentExcel.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
  },
});

export const { updateWorkingDay, updatePersonnelByDepartment, resetDepartmentReport } =
  departmentSlice.actions;
export default departmentSlice.reducer;
